module.exports = __webpack_public_path__ + "img/aParty_042724_F.2764efd8.jpg";